<template>
<v-card>
<v-container fluid>
<v-card>
<form ref="form"
v-model="valid"
lazy-validation>
    <v-row align="start"
        no-gutters
        style="height: 75px;">

    <v-col cols="12" sm="2" md="2">
      <v-container>
        <v-text-field v-model="editedItem.puntoOp" 
        label="Punto Opcional" 
        type="input"
        hint="Ingrese punto op. ej: 10087"
        ></v-text-field>
      </v-container>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-container>
          <v-autocomplete v-model="editedItem.seleccion"
            :items="RequestMVM"
            label= "Seleccione"
            
            ></v-autocomplete>
        </v-container>
    </v-col>
    <v-col cols="12" sm="6" md="3">
        <v-container>
            <v-text-field v-model="editedItem.ingresadato" 
            label="Ingresa el dato" 
            type="input"
            :hint="editedItem.seleccion == 'Hora del Turno' ? 'dato sin punto. Formato de hora 00:00' : ''"
            :disabled="editedItem.seleccion == 'Fecha del Turno' || editedItem.seleccion == 'Fecha de Cambio'"
            :rules="datoRule"
            ></v-text-field>
        </v-container>
    </v-col>
    <v-col cols="12" sm="6" md="3">
        <v-container>
            <v-menu v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            v-if="editedItem.seleccion == 'Fecha del Turno' || editedItem.seleccion == 'Fecha de Cambio'"
            >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="editedItem.fecha"
                    label="Ingrese Fecha"
                    prepend-icon="mdi-calendar-today"
                    :rules="fechaRule"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    ></v-text-field>
            </template>
            <v-date-picker v-model="editedItem.fecha" @input="menu = false"></v-date-picker>
            </v-menu>
        </v-container>
    </v-col>
    <v-spacer></v-spacer>
    </v-row>
    <v-row align="center"
        no-gutters
        > 
      <v-col cols="12" sm="6" md="3" >
        <v-container >
          <v-btn :disabled="btn" color="primary" @click="submit">Buscar</v-btn>
        </v-container>
      </v-col>
      
    </v-row>
    <v-spacer></v-spacer>
    
</form>  
  <v-spacer></v-spacer>
  </v-card>
  </v-container>
  <v-container fluid>
    <v-card>
     <v-card-title>
       <v-icon x-large>mdi-clipboard-list-outline</v-icon>Consultas y movimientos en OC
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="mvm"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
 
  </v-data-table>
  </v-card>
  </v-container>
  <v-spacer></v-spacer>
<template>
<div class="text-center">
    <v-btn type="button" color="primary" @click="onexport">Descargar Movimientos</v-btn>
    
</div>

</template>
  <v-dialog v-model="dialog_new" max-width="900px">
  <v-stepper v-model="e1" vertical>
         <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
        <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">Buscando Movimientos
            <small>Consultando</small>
        </v-stepper-step>
        <v-stepper-content step="1">
        <v-card height="100px">
            <div class="text-center">
            <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
            {{this.msj_proceso}}
            </div>
        </v-card>
        </v-stepper-content>  
    </v-stepper>
  </v-dialog>
  </v-card>
</template>

<script>
import axios from 'axios'
//import Vue from "vue";
//import JsonExcel from "vue-json-excel";
import XLSX from 'xlsx';
 
//Vue.component("downloadExcel", JsonExcel);

export default {
  data: () => ({
    
    search: '',
    search2: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    dialog_detail: false,
    valid: true,
    menu: false,
    menu2: false,
    e1: 0,
    btn: false,
    msj_proceso:'',
    progressBar1: false,
    progressBar: false,
    overlay: false,
    step_error1: true,
    step_error2: true,
    step_error3: true,
    step_color1:"primary",
    step_color2:"primary",
    step_color3:"primary",
    RequestProposal_id:'',
    TurningStorageArea_id:'',
    TurningStorageArea_Desc:'',
    OpPoint_id: '',
    Supplier_Description:'',
    VendorPurchaseOrder_Num:'',
    Section_id:'',
    LastOpRepUser_id: '',
    RepEvent_Dttm: '',
    ApiUser_GivenName:'',
    status:'',
    CDay_id:'',
    CHour_Description:'',
    DateMvm:'',
    headers: [
      { text: 'PropuestaID', value: 'RequestProposal_id' },
      { text: 'OC', value: 'VendorPurchaseOrder_Num' },
      { text: 'Punto', value: 'OpPoint_id' },
      { text: 'AlmacenID', value: 'TurningStorageArea_id' },
      { text: 'Almacén', value: 'TurningStorageArea_Desc' },
      { text: 'Prov', value: 'TurnSrcSupplier_id' },  
      { text: 'R Social', value: 'Supplier_Description' },
      { text: 'Sección', value: 'Section_id'},    
      { text: 'Btos x pallet', value: 'RequestLayer_Qty' },
      { text: 'Bul Ped', value: 'RequestPack_Qty'},
      { text: 'Pallets', value: 'RequestPallet_Qty'},
      { text: 'Fecha de turno', value: 'CDay_id' },
      { text: 'Hora del Turno', value: 'CHour_Description' },  
      { text: 'Tipo Turno', value: 'TurnAssignmentType_id'},
      { text: 'Turno Cant', value: 'Turn_Qty' },
      { text: 'status', value: 'status' },
      { text: 'UsuarioID', value: 'LastOpRepUser_id'},
      { text: 'Nombre Usuario', value: 'ApiUser_GivenName'},
      { text: 'Fecha de cambio', value: 'DateMvm'},
      { text: 'Hora de cambio', value: 'RepEvent_Dttm'}
    ],
    mvm: [],
    tdetalle: [],
    seleccion:[],
    RequestMVM: ['Propuesta ID', 'Número de Orden', 'Punto', 'Almacen ID', 'Almacén', 'Proveedor', 'R Social', 'Sección id', 'Btos x pallet',  'Bul Ped', 'Pallets',  'Fecha del Turno', 'Hora del Turno', 'status', 'Usuario id', 'Nombre de Usuario', 'Fecha de Cambio'],
    tdetalle_vew: [],
    editedIndex: -1,
    editedItem: {
      seleccion:['Propuesta ID', 'Número de Orden', 'Punto', 'Almacen ID', 'Almacén', 'Proveedor', 'R Social','Sección id', 'Btos x pallet',  'Bul Ped', 'Pallets',  'Fecha del Turno', 'Hora del Turno', 'status', 'Usuario id', 'Nombre de Usuario', 'Fecha de Cambio'],
      ingresadato: [],
      fecha: new Date().toISOString().substr(0, 10),
      files: []
    },
    
    fechaRule: [
        v => !!v || 'Fecha es requerida'
    ],
    datoRule: [
        v => !!v || 'El dato es Requerido'
       
    ],
    
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Planning' : 'Editar Planning'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      
      /* axios.post(this.api_tool_url + '/get_planning', this.editedItem, this.config)
        .then(response => {
            this.mvm = response.data.ResultRows
             if(response.data.ResultRows.length >= 1)
             {
                 axios.post(this.api_tool_url + '/get_planning_detail', this.editedItem, this.config)
                    .then(response => {
                        this.tdetalle = response.data.ResultRows
                    })
                    .catch(error => {
                        this.tdetalle = []
                        alert(error.response.data.message)
                    })
             }
        })
        .catch(error => {
          this.mvm = []
          alert(error.response.data.message)
        }), */

        
    },

    submit () {
      this.btn = true
      this.dialog_new = true
      this.e1 = 1
      this.progressBar = true
      this.step_error1= true
      this.step_error2= true
      this.step_error3= true
      this.step_color1="primary",
      this.step_color2="primary",
      this.step_color3="primary",
      this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
      
      axios.post(this.api_tool_url + '/get_movimientosOC', this.editedItem, this.config)
          .then(response => {
            
            if(response.data.ResultRows.length >= 1)
            {
                console.log(response.data.ResultRows)
                this.mvm = response.data.ResultRows
                this.e1 = 2
                this.step_color1 = "#008000"
                this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
                this.progressBar = true
                axios.post(this.api_tool_url + '/get_movimientosOC_Detail', this.editedItem, this.config)
                .then(response => {
                    if(response.data.ResultRows.length >= 1)
                    {
                        this.tdetalle = response.data.ResultRows
                        this.e1 = 3
                        this.step_color2 = "#008000"
                        this.progressBar = false
                        this.msj_proceso = 'Se realizo la busqueda correctamente'
                        

                    }
                    else{
                        this.progressBar = false
                        this.msj_proceso = "No se encontro detalle."
                        this.step_error2 = false
                        this.step_error3 = false
                    }
                })
                .catch(error => {
                    this.tdetalle = []
                    this.btn = false
                    this.step_error2 = false
                    this.progressBar = false
                    this.msj_proceso = error.response.data.message
                })
            }
            else{
                this.msj_proceso = "No se encontrarón movimientos."
                this.progressBar = false
                this.step_error1 = false
                this.step_error2 = false
                this.step_error3 = false
            }
            this.btn = false
          })
          .catch(error => {
            this.mvm = []
            this.btn = false
            this.step_error1 = false
            this.progressBar = false
            this.msj_proceso = error.response.data.message
          })
    },

    close () {
      this.dialog_new = false
    },
    close2 () {
      this.dialog_detail= false
    },

    onexport () { // On Click Excel download button
    
      // export json to Worksheet of Excel
      // only array possible
      const header_r_f = ['Propuesta ID', 'OC', 'Punto', 'Almacen ID', 'Almacen', 'Prov', 'R Social','Seccion', 'Btos x pallet',  'Bul Ped', 'Pallets', 'Fecha de Turno', 'Hora del Turno', 'Tipo Turno', 'Turno Cant','status', 'UsuarioID', 'Nombre Usuario', 'Fecha de Cambio', 'Hora de cambio'];
      const header_r = ['RequestProposal_id','VendorPurchaseOrder_Num','OpPoint_id','TurningStorageArea_id','TurningStorageArea_Desc','TurnSrcSupplier_id','Supplier_Description','Section_id', 'RequestLayer_Qty', 'RequestPack_Qty', 'RequestPallet_Qty', 'CDay_id','CHour_Description','TurnAssignmentType_id', 'Turn_Qty', 'status', 'LastOpRepUser_id', 'ApiUser_GivenName', 'DateMvm','RepEvent_Dttm',];
      var resumenWS = XLSX.utils.json_to_sheet(this.mvm, {header: header_r}) 
      
      const header_d_f = ['Propuesta ID', 'Num. Linea','OC', 'Punto', 'Almacen ID', 'Almacen', 'Prov', 'R Social','Seccion', 'Btos x pallet',  'Bul Ped', 'Pallets',  'Fecha de Turno', 'Hora del Turno', 'Tipo Turno', 'Turno Cant','status', 'UsuarioID', 'Nombre Usuario', 'Fecha de Cambio', 'Hora de cambio'];
      const header_d = ['RequestProposal_id','RequestProposalLine_id','VendorPurchaseOrder_Num','OpPoint_id','TurningStorageArea_id','TurningStorageArea_Desc','TurnSrcSupplier_id','Supplier_Description','Section_id', 'RequestLayer_Qty', 'RequestPack_Qty', 'RequestPallet_Qty', 'CDay_id','CHour_Description','TurnAssignmentType_id', 'Turn_Qty', 'status', 'LastOpRepUser_id', 'ApiUser_GivenName', 'DateMvm','RepEvent_Dttm',];
       var detalleWS = XLSX.utils.json_to_sheet(this.tdetalle, {header: header_d}) 

      var range = XLSX.utils.decode_range(resumenWS['!ref']);
      for(var C = range.s.c; C <= range.e.c; ++C) {
        var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
        resumenWS[colum].v = header_r_f[C];
      }

      range.e['c'] = header_r_f.length - 1;
      resumenWS['!ref'] = XLSX.utils.encode_range(range);

      var range = XLSX.utils.decode_range(detalleWS['!ref']);
      for(var C = range.s.c; C <= range.e.c; ++C) {
        var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
        detalleWS[colum].v = header_d_f[C];
      }

      range.e['c'] = header_d_f.length - 1;
      detalleWS['!ref'] = XLSX.utils.encode_range(range);

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, resumenWS, 'Resumen') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, detalleWS, 'Detalle')  
        
      var file='Movimientos_OC.xlsx';

      // export Excel file
      XLSX.writeFile(wb, file) // name of the file is 'book.xlsx'
    }
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RequestProposalMVMGrid.vue